import { ZONTGeocoding } from 'shared/api/geocoding';
import { downloadBlob } from '../utils/download-files/download-blob';
import { TextEncoderLite } from 'text-encoder-lite';
import { getFileType } from '../utils/download-files/download_file';
import { loadDataFromServerForZontGraphs } from 'console/tabs/graphs/components/graph/loadDataFromServer';
import { loadDataFromServer } from 'shared/device.map.track/api';
export function functionsWithAPI(api) {
    return async (request) => {
        switch (request.type) {
            case 'load_data':
                try {
                    return await loadDataFromServer(api, request.selected_device_ids, request.time.mintime, request.time.maxtime);
                }
                catch (e) {
                    console.error('error_load_data_in_worker', e);
                    throw e;
                }
            case 'load_data_for_zont_graphs':
                try {
                    const result = await loadDataFromServerForZontGraphs(api, request.requests);
                    return result;
                }
                catch (e) {
                    console.error('error_load_data_in_worker', e);
                    throw e;
                }
            case 'geocode': {
                return await new Promise((resolve) => ZONTGeocoding.geocode_many_and_extract(api, request.locs, (geo_results) => {
                    resolve(geo_results);
                }));
            }
            case 'download_dump': {
                downloadBlob(new TextEncoderLite().encode(request.dump), request.filename, getFileType(request.filename), false);
                return Promise.resolve();
            }
            default:
                return;
        }
    };
}
